import React, { useEffect, useState } from "react";
import { checkAuthState } from "../../../../../../authentication/auth-utils/auth-utils";
import { useNavigate } from 'react-router-dom';
import ItemInformationList from "./item-information-list/item-information-list";
import ItemsEdit from "../../../../items-edit/items-edit";
import ItemsDelete from "../../../../items-delete/items-delete";

const ItemInformationContainer = (props) => {
    const item_id = props.item_id;
    const formData = props.formData;
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(null);

    useEffect(() => {
        checkAuthState((isLoggedIn) => {
          setIsAuthorized(isLoggedIn);
        });
    }, []);

    useEffect(() => {
        if (isAuthorized === false) {
          navigate('/');
        }
    }, [isAuthorized, navigate]);

    return (
        <>
            <div style={{ padding: 20 }}>
                {/* <ItemInformationList item_id={item_id} /> */}
                <ItemInformationList item_id={item_id} formData={formData}/>
                <ItemsEdit/>
                <ItemsDelete/>
            </div>
        </>
    )
};

export default ItemInformationContainer;